<template>
  <div :class="['w-100', { 'modal-active': selected }]">
    <div class="modal tw-bg-white tw-text-gray-600" v-click-outside="hideModal">
      <div class="header">
        <span v-if="selected == 'Ajuda'">Ajuda</span>
        <span v-else>Seus projetos</span>
      </div>
      <hr />
      <div class="container" v-if="selected == 'Ajuda'">
        <AppMenuButton
          class="tw-w-[260px] tw-justify-between"
          leading-icon="whatsapp"
          trailing-icon="arrow"
          truncate
          @click="openWhatsapp"
        >
          Falar com suporte
        </AppMenuButton>
        <AppMenuButton
          class="tw-w-[260px] tw-justify-between"
          leading-icon="support-contact"
          trailing-icon="arrow"
          truncate
          @click="goToHelpCenter"
        >
          Help Center
        </AppMenuButton>
      </div>
      <div class="container" v-else>
        <RadioOption
          class="tw-w-[260px]"
          v-for="project in projects"
          :key="`${project.id}_${project.title}`"
          :text="project.title"
          :selected="authStore.currentPharmaceutical.id === project.id"
          @radio:click="() => changeProject(project.id)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { useAuthStore } from '@/store/pinia/auth'
import RadioOption from '@/v2/components/menu-drawer/desktop/partials/RadioOption.vue'
import AppMenuButton from '@/v2/components/ui/menu/AppMenuButton.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters: authGettersMap } = createNamespacedHelpers('auth')

export default {
  name: 'SidebarModal',
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
  },
  components: {
    AppMenuButton,
    RadioOption,
  },
  props: {
    selected: {
      type: String,
      default: null,
    },
    projects: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      radioSelected: null,
    }
  },
  computed: {
    ...authGettersMap(['pharmaceuticalDomainConfig', 'userName']),
  },
  methods: {
    hideModal() {
      this.$emit('handle')
    },
    async changeProject(pharmaceuticalId) {
      this.radioSelected = pharmaceuticalId

      this.authStore.setToken(token)
      this.authStore.setInitiated(false)
      this.authStore.setCurrentHomePage('home')

      const homeRoute = this.$router.resolve({ name: 'home' })

      window.location.assign(homeRoute.href)
    },
    async getDefaultHomePage(pharmaceuticalId) {
      const { value } = await this.$api.getParameterWithoutLogin('DEFAULT_HOME_PAGE', pharmaceuticalId)

      return value
    },
    openWhatsapp() {
      const message = `Olá me chamo ${this.authStore.session.user.name}, estou na plataforma Bioplanner e preciso de ajuda.`

      const link = `https://api.whatsapp.com/send?phone=5511998933332&text=${message}&lang=pt_br`
      window.open(link, '_blank')
    },
    goToHelpCenter() {
      window.open('https://www.notion.so/Kintsu-s-Help-Center-434b8199a5854f0aacb0cf94505d897d?pvs=24', '_blank')
    },

    handleClickOutside(event) {
      const el = this.$refs.tab
      if (!el.contains(event.target)) {
        this.$emit('handle', event)
      }
    },
  },
  setup() {
    const authStore = useAuthStore()
    return {
      authStore,
    }
  },
}
</script>
<style scoped>
.modal-active {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(11, 23, 67, 0.2);
  padding: 16px 8px;
  z-index: 999 !important;
}

.modal {
  border: 1px solid #cecece;
  border-radius: 12px;
  width: 276px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
}

.modal .header {
  margin: 8px 16px;
  font-size: 16px;
}

.modal .container {
  display: flex;
  flex-direction: column;
}

.modal .container button {
  height: 44px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.modal .container button div > *:first-child {
  margin-right: 12px;
}

.modal .container button div {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
